import './../libs/scrolloverflow.min.js'
import Fullpage from './../libs/fullpage'
import { $ } from './../helpers/query'
import SectionAnimation from './SectionAnimation'
import Progressbar from './ProgressBar'

export default class {
  constructor() {
    this.fullpage;
    this.fullpageSelector = '#fullpage';
    this.anchorsAttr = 'data-to-anchor';
    this.anchorsLinks = $(`[${this.anchorsAttr}]`);
    this.menuLinks = document.getElementById('header').querySelectorAll('.menu__link');
    this.eventBlocked = new Event('fullpageBlocked');
    this.progressbar = new Progressbar();
    this.animations = new SectionAnimation();
    this.currentSection = document.querySelector('.fullpage__section');
    this.onLeaveWork = false;
    this.swipeStart = 0;
    this.swipeEnd = 0;
    this.scrollDisabled = false;
  }

  init() {
    this.toggleFullpage()
    this.bindEvents()
    this.animations.init()
  }

  bindEvents() {
    window.addEventListener('preloaderComplete', () => {
      if (this.fullpage) {
        this.enableScroll()
      }
    })

    window.addEventListener('sectionTransitionStart', () => {
      if (this.fullpage) {
        this.disableScroll()
      }
    })

    window.addEventListener('sectionTransitionEnd', () => {
      if (this.fullpage) {
        this.enableScroll()
      }
    })

    this.anchorsLinks.on('click', (e, link) => {
      if (this.fullpage) {
        e.preventDefault()
        const linkHref = link.getAttribute(this.anchorsAttr);
        this.fullpage.silentMoveTo(linkHref)
      }
    })

    window.addEventListener('modalOpen', () => {
      if (this.fullpage) {
        this.disableScroll()
      }
    })

    window.addEventListener('modalClose', () => {
      if (this.fullpage && !this.currentSection.matches('#photos-section') && !this.currentSection.matches('#features-section')) {
        this.enableScroll()
      }
    })

    window.addEventListener('resize', () => {
      this.toggleFullpage()
    })

    window.addEventListener('fullpageSlidePrev', () => {
      if (this.fullpage) {
        this.fullpage.moveSectionUp();
      }
    });

    window.addEventListener('fullpageSlideNext', () => {
      if (this.fullpage) {
        this.fullpage.moveSectionDown();
      }
    });
  }

  toggleFullpage() {
    if (document.documentElement.clientWidth >= 640 && !this.fullpage) {
      this.createFullpage()
    } else if (document.documentElement.clientWidth < 640 && this.fullpage) {
      this.fullpage.destroy('all')
    }
  }

  createFullpage() {
    this.fullpage = new Fullpage(this.fullpageSelector, {
      licenseKey: '5539DAA8-C066469D-AB430B59-2F40DE5A',
      sectionSelector: '.fullpage__section',
      scrollOverflow:true,
      lockAnchors: true,
      scrollingSpeed: 600,
      easingcss3: 'step-end',
      dragAndMove: 'fingersonly',
      verticalCentered: false,
      onLeave: (origin, destination, direction) => {
        this.onLeaveWork = true;
        this.currentSection = destination.item;

        this.progressbar.updateInFullpage(destination.item)

        this.toggleMenuLinksActiveState(destination.item)

        this.initScrollAnimation(origin.item, destination.item, direction)
      }
    })
    this.disableScroll()
  }

  toggleMenuLinksActiveState(destination) {
    const anchorId = destination.getAttribute('data-anchor');
    this.menuLinks.forEach((link, i) => {
      if (link.matches(`[data-to-anchor="${anchorId}"]`)) {
        link.classList.add('active')
      } else {
        link.classList.remove('active')
      }
    });
  }

  enableScroll() {
    this.fullpage.setAllowScrolling(true)
    this.fullpage.setKeyboardScrolling(true)
    this.scrollDisabled = false;
  }

  disableScroll() {
    this.fullpage.setAllowScrolling(false)
    this.fullpage.setKeyboardScrolling(false)
    this.scrollDisabled = true;
    window.dispatchEvent(this.eventBlocked)
  }

  initScrollAnimation(origin, destination, direction) {
    if (direction == 'down') {
      if (origin.matches('#hero-section')) this.animations.heroAnim.onLeave();
      if (origin.matches('#intro-section')) this.animations.introAnim.onLeaveDown();
      if (origin.matches('#photos-section')) this.animations.photosAnim.onLeaveDown();
      if (origin.matches('#map-intro-section')) this.animations.mapIntroAnim.onLeaveDown();
      if (origin.matches('#map-section')) this.animations.mapAnim.onLeaveDown();
      if (origin.matches('#features-section')) this.animations.featuresAnim.onLeaveDown();
      if (origin.matches('#building-intro-section')) this.animations.buildIntroAnim.onLeaveDown();
      if (origin.matches('#building-section')) this.animations.buildAnim.onLeave();
      if (origin.matches('#specifications-intro-section')) this.animations.specIntroAnim.onLeaveDown();
      if (origin.matches('#specifications-section')) this.animations.specAnim.onLeave();
      if (origin.matches('#sustainability-intro-section')) this.animations.sustIntroAnim.onLeave();
      if (origin.matches('#sustainability-section')) this.animations.sustAnim.onLeaveDown();
      if (origin.matches('#gallery-section')) this.animations.galleryAnim.onLeaveDown();
      if (origin.matches('#downloads-section')) this.animations.downloadAnim.onLeaveDown();

      if (destination.matches('#intro-section')) this.animations.introAnim.onVisitDown();
      if (destination.matches('#photos-section')) this.animations.photosAnim.onVisitDown();
      if (destination.matches('#map-intro-section')) this.animations.mapIntroAnim.onVisitDown();
      if (destination.matches('#map-section')) this.animations.mapAnim.onVisitDown();
      if (destination.matches('#features-section')) this.animations.featuresAnim.onVisitDown();
      if (destination.matches('#building-intro-section')) this.animations.buildIntroAnim.onVisitDown();
      if (destination.matches('#building-section')) this.animations.buildAnim.onVisitDown();
      if (destination.matches('#specifications-intro-section')) this.animations.specIntroAnim.onVisitDown();
      if (destination.matches('#specifications-section')) this.animations.specAnim.onVisitDown();
      if (destination.matches('#sustainability-intro-section')) this.animations.sustIntroAnim.onVisitDown();
      if (destination.matches('#sustainability-section')) this.animations.sustAnim.onVisitDown();
      if (destination.matches('#gallery-section')) this.animations.galleryAnim.onVisitDown();
      if (destination.matches('#downloads-section')) this.animations.downloadAnim.onVisitDown();
      if (destination.matches('#footer')) this.animations.footerAnim.onVisit();
    } else {
      if (origin.matches('#intro-section')) this.animations.introAnim.onLeaveUp();
      if (origin.matches('#photos-section')) this.animations.photosAnim.onLeaveUp();
      if (origin.matches('#map-intro-section')) this.animations.mapIntroAnim.onLeaveUp();
      if (origin.matches('#map-section')) this.animations.mapAnim.onLeaveUp();
      if (origin.matches('#features-section')) this.animations.featuresAnim.onLeaveUp();
      if (origin.matches('#building-intro-section')) this.animations.buildIntroAnim.onLeaveUp();
      if (origin.matches('#building-section')) this.animations.buildAnim.onLeave();
      if (origin.matches('#specifications-intro-section')) this.animations.specIntroAnim.onLeaveUp();
      if (origin.matches('#specifications-section')) this.animations.specAnim.onLeave();
      if (origin.matches('#sustainability-intro-section')) this.animations.sustIntroAnim.onLeave();
      if (origin.matches('#sustainability-section')) this.animations.sustAnim.onLeaveUp();
      if (origin.matches('#gallery-section')) this.animations.galleryAnim.onLeaveUp();
      if (origin.matches('#downloads-section')) this.animations.downloadAnim.onLeaveUp();
      if (origin.matches('#footer')) this.animations.footerAnim.onLeave();

      if (destination.matches('#hero-section')) this.animations.heroAnim.onVisit();
      if (destination.matches('#intro-section')) this.animations.introAnim.onVisitUp();
      if (destination.matches('#photos-section')) this.animations.photosAnim.onVisitUp();
      if (destination.matches('#map-intro-section')) this.animations.mapIntroAnim.onVisitUp();
      if (destination.matches('#map-section')) this.animations.mapAnim.onVisitUp();
      if (destination.matches('#features-section')) this.animations.featuresAnim.onVisitUp();
      if (destination.matches('#building-intro-section')) this.animations.buildIntroAnim.onVisitUp();
      if (destination.matches('#building-section')) this.animations.buildAnim.onVisitUp();
      if (destination.matches('#specifications-intro-section')) this.animations.specIntroAnim.onVisitUp();
      if (destination.matches('#specifications-section')) this.animations.specAnim.onVisitUp();
      if (destination.matches('#sustainability-intro-section')) this.animations.sustIntroAnim.onVisitUp();
      if (destination.matches('#sustainability-section')) this.animations.sustAnim.onVisitUp();
      if (destination.matches('#gallery-section')) this.animations.galleryAnim.onVisitUp();
      if (destination.matches('#downloads-section')) this.animations.downloadAnim.onVisitUp();
    }
  }
}
